import { createContext, useContext, useState, useEffect } from 'react';

const SidebarContext = createContext();

/**
 * Sidebar context - provides state to layout components about current screen size and whether the sidebar is open, as well as a setter to set sidebar as open/closed.
 * 
 * @returns {Object} The sidebar context
 * 
 */
export const useSidebar = () => {
    const context = useContext(SidebarContext);
    if(!context){
        throw new Error('useSidebar must be used within a SidebarProvider');
    }
    return context;
}

export const SidebarProvider = ({children}) => {
    const [isOpen, setIsOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const updateScreenState = () => {
            const mobile = window.innerWidth < 800;
            setIsMobile(mobile);
        };
    
        updateScreenState(); // run once on mount
    
        window.addEventListener("resize", updateScreenState);
    
        return () => window.removeEventListener("resize", updateScreenState);
      }, []);

    const contextValue = {
        isOpen,
        setIsOpen,
        isMobile
    }

    return (
        <SidebarContext.Provider value={contextValue}>
            {children}
        </SidebarContext.Provider>
    )
}